var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiFolderInfoFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7743 4.53336H22.9327C23.2156 4.53336 23.4869 4.64574 23.6869 4.84578C23.887 5.04582 23.9993 5.31713 23.9993 5.60002V20.5334C23.9993 20.8163 23.887 21.0876 23.6869 21.2876C23.4869 21.4876 23.2156 21.6 22.9327 21.6H3.73268C3.44978 21.6 3.17847 21.4876 2.97844 21.2876C2.7784 21.0876 2.66602 20.8163 2.66602 20.5334V3.46669C2.66602 3.18379 2.7784 2.91248 2.97844 2.71244C3.17847 2.5124 3.44978 2.40002 3.73268 2.40002H11.6409L13.7743 4.53336ZM12.266 8.80002V10.9334H14.3993V8.80002H12.266ZM12.266 12V17.3334H14.3993V12H12.266Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiFolderInfoFill);
export default __webpack_public_path__ + "static/media/ri_folder-info-fill.b65608e42a57040d27b2a87a39d75a68.svg";
export { ForwardRef as ReactComponent };